import { BulkTypes } from "./BulkPayment";
import { Pleb, PlebData } from "./Pleb";

export interface Transaction {
  status: TransactionStatus;
  paymentHash: string;
  amount: number;
  fee: number;
  opaFee?: number;
  routingFee?: number;
  comment: string;
  time: string;
  read: boolean;
  announced?: boolean;
  newBalance?: number;
  isInternal?: boolean;
  sender?: {
    type: PaymentMethod;
    lnurl?: string;
    invoice?: string;
    internalUser?: PlebData;
  };
  recipient?: {
    type: PaymentMethod;
    lnurl?: string;
    invoice?: string;
    internalUser?: PlebData;
  };
  type: PaymentType;
  bulk?: {
    type?: BulkTypes;
    name: string;
    nbToSend: number;
    nbSendedSuccess: number;
    nbSendedError: number;
    geoZap?: {
      addressType?: string;
      countryCode?: string;
      countryImgUrl?: string;
    }
  },
  fromBulk?: {
    type?: BulkTypes;
    name?: string;
    id?: string;
  }
}

export enum PaymentType {
  individual = 'individual',
  bulk = 'bulk',
  bulk_individual = 'bulk_individual',
}

export enum PaymentMethod {
  LNURL = 'lnurl',
  INVOICE = 'invoice',
}

export enum TransactionStatus {
  PENDING = 'pending',
  SUCCESS = 'success',
}

export const apiResponseToTransaction = (apiResponse: any): Transaction => {
  const transaction = apiResponse as Transaction;
  if(transaction.recipient && transaction.recipient.internalUser)
    transaction.recipient.internalUser = Pleb.fromJson({user: apiResponse.recipient.internalUser}, '').toJson();
  if(transaction.sender && transaction.sender.internalUser)
    transaction.sender.internalUser = Pleb.fromJson({user: apiResponse.sender.internalUser}, '').toJson();
  return transaction;
}